define('views/components/cd_manager/cd_manager',['require','backbone','text!templates/components/cd_manager/cd_manager.html'],function(require){

    var Backbone = require('backbone');

    var temp = require("text!templates/components/cd_manager/cd_manager.html");
    return Backbone.Marionette.ItemView.extend({
        tagName: 'tr',
        template: _.template(temp),
        className: 'cd-manager-item'
    });
});
